import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'edl-generic-modal',
    templateUrl: './edl-generic-modal.component.html'
})
export class EdlGenericModalComponent {
    @Input() title?: string = '';
    @Input() message?: string = '';
    @Input() confirmLabel?: string = '';
    @Input() cancelLabel?: string = '';

    constructor(public activeModal: NgbActiveModal) {}
}